import { render, staticRenderFns } from "./batchOpenDialog.vue?vue&type=template&id=38a2e203"
import script from "./batchOpenDialog.vue?vue&type=script&lang=js"
export * from "./batchOpenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports